import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getAllEventAttachmentsAsync, uploadDocumentAsync, createEventAttachmentAsync, deleteEventAttachmentAsync } from './vdkEventDocumentThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const vdkEventDocumentSlice = createSlice({
    name: 'vdkEventDocument',
    initialState,
    reducers: {
        clearUploadedDocument: (state) => {
            state.uploadedDocument = undefined;
            state.apiError = undefined;
        },
        clearEventAttachments: (state) => {
            state.eventAttachments = undefined;
            state.eventAttachmentsTotalCount = undefined;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(uploadDocumentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(uploadDocumentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.uploadedDocument = action.payload;
        })
            .addCase(uploadDocumentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getAllEventAttachmentsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllEventAttachmentsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.eventAttachments = action.payload.items;
            state.eventAttachmentsTotalCount = action.payload.totalCount;
        })
            .addCase(getAllEventAttachmentsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(createEventAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createEventAttachmentAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(createEventAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(deleteEventAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteEventAttachmentAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteEventAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearUploadedDocument, clearEventAttachments } = vdkEventDocumentSlice.actions;
export default vdkEventDocumentSlice.reducer;
